import React, { Component } from 'react'
import pt from 'prop-types'
import { connect } from 'react-redux'
import { setThumbnailType, setLayoutType } from '../../modules/viewSettings'

import './CollectionViewMenu.scss'

import ViewBarArrowUp from '../icon/ViewBarArrowUp'
import ViewBarArrowDown from '../icon/ViewBarArrowDown'
import ViewBarArrowTimeUp from '../icon/ViewBarArrowTimeUp'
import ViewBarArrowTimeDown from '../icon/ViewBarArrowTimeDown'
import ViewBarArrowAlphUp from '../icon/ViewBarArrowAlphUp'
import ViewBarArrowAlphDown from '../icon/ViewBarArrowAlphDown'
import FeedTrim from '../icon/FeedTrim'
import FeedSquare from '../icon/FeedSquare'
import FeedPoster from '../icon/FeedPoster'
import FeedStack from '../icon/FeedStack'
import FeedGrid from '../icon/FeedGrid'
import FeedGallery from '../icon/FeedGallery'
import FeedStage from '../icon/FeedStage'

class CollectionViewMenu extends Component {
  render() {
    const { type, setOrder, switchMenu, itemsOrder, setThumbnailType, setLayoutType, viewSettings } = this.props

    let optionsList
    switch (type) {
      case 'sort':
        optionsList = {
          title: 'Sort',
          class: 'sort',
          items: [
            [
              {
                icon: <ViewBarArrowUp />,
                class: 'customUp',
                text: 'Custom Order',
                active: itemsOrder === 'custom',
                f: e => {
                  setOrder({ order: 'custom' })
                }
              },
              {
                icon: <ViewBarArrowDown />,
                class: 'customDown',
                text: 'Custom Order Flipped',
                active: itemsOrder === 'flipped',
                f: e => {
                  setOrder({ order: 'flipped' })
                }
              },
              {
                icon: <ViewBarArrowTimeUp />,
                class: 'dateUp',
                text: 'Date Added (Most Recent at Top)',
                active: itemsOrder === 'date_added',
                f: e => {
                  setOrder({ order: 'date_added' })
                }
              },
              {
                icon: <ViewBarArrowTimeDown />,
                class: 'dateDown',
                text: 'Date Added (Most Recent at Bottom)',
                active: itemsOrder === 'date_added_asc',
                f: e => {
                  setOrder({ order: 'date_added_asc' })
                }
              },
              {
                icon: <ViewBarArrowAlphUp />,
                class: 'titleUp',
                text: 'Card Title (A to Z)',
                active: itemsOrder === 'name',
                f: e => {
                  setOrder({ order: 'name' })
                }
              },
              {
                icon: <ViewBarArrowAlphDown />,
                class: 'titleDown',
                text: 'Card Title (Z to A)',
                active: itemsOrder === 'name_asc',
                f: e => {
                  setOrder({ order: 'name_asc' })
                }
              }
            ]
          ]
        }
        break
      case 'viewMode':
        optionsList = {
          title: 'Item Layout',
          class: 'viewMode',
          items: [
            [
              {
                icon: <FeedStack />,
                class: 'list',
                text: 'List',
                active: viewSettings.get('layoutType') === 'list',
                f: e => {
                  setLayoutType('list')
                }
              },
              {
                icon: <FeedGrid />,
                class: 'grid',
                text: 'Grid',
                active: viewSettings.get('layoutType') === 'grid',
                f: e => {
                  setLayoutType('grid')
                }
              },
              {
                icon: <FeedGallery />,
                class: 'gallery',
                text: 'Gallery',
                active: viewSettings.get('layoutType') === 'gallery',
                f: e => {
                  setLayoutType('gallery')
                }
              },
              {
                icon: <FeedStage />,
                class: 'stage',
                text: 'Stage',
                active: viewSettings.get('layoutType') === 'stage',
                f: e => {
                  setLayoutType('stage')
                }
              }
            ]
          ]
        }
        break
      case 'thumbsMode':
        optionsList = {
          title: 'Thumbnail Style',
          class: 'thumbsMode',
          items: [
            [
              {
                icon: <FeedTrim />,
                class: 'trim',
                text: 'Trim',
                active: viewSettings.get('thumbnailType') === 'trimmed',
                f: e => {
                  setThumbnailType('trimmed')
                }
              },
              {
                icon: <FeedSquare />,
                class: 'square',
                text: 'Square',
                active: viewSettings.get('thumbnailType') === 'squared',
                f: e => {
                  setThumbnailType('squared')
                }
              },
              {
                icon: <FeedPoster />,
                class: 'poster',
                text: 'Poster',
                active: viewSettings.get('thumbnailType') === 'poster',
                f: e => {
                  setThumbnailType('poster')
                }
              }
            ]
          ]
        }
        break
      case 'context':
        optionsList = {
          title: 'Context',
          class: 'context',
          items: [
            [
              {
                icon: <ViewBarArrowUp />,
                class: 'customUp',
                text: 'Custom Order',
                active: false,
                f: e => {
                  setOrder()
                }
              }
            ]
          ]
        }
        break

      default:
        break
    }

    return (
      <div
        className={'collection-view-menu' + ' collection-view-menu--' + optionsList.class}
        onMouseLeave={e => {
          switchMenu(e, { state: false })
        }}
      >
        <div className="collection-view-menu__title">{optionsList.title}</div>
        <ul className="collection-view-menu__list">
          {optionsList.items.map(listItem => (
            <li className="collection-view-menu__item" key={listItem[0].text}>
              <ul className="collection-view-menu__sublist">
                {listItem.map(listSubItem => (
                  <li
                    className={
                      'collection-view-menu__subitem' +
                      (listSubItem.active ? ' collection-view-menu__subitem--active' : '') +
                      (listSubItem.class ? ' collection-view-menu__subitem--' + listSubItem.class : '')
                    }
                    onMouseDown={e => {
                      listSubItem.f && listSubItem.f(e)
                      switchMenu(e, { state: false })
                    }}
                    key={listSubItem.text}
                  >
                    <span
                      className={
                        'collection-view-menu__icon ' +
                        (listSubItem.class ? 'collection-view-menu__icon--' + listSubItem.class : '')
                      }
                    >
                      {listSubItem.icon}
                    </span>
                    {listSubItem.textInactive && listSubItem.active ? listSubItem.textInactive : listSubItem.text}
                  </li>
                ))}
              </ul>
            </li>
          ))}
        </ul>
      </div>
    )
  }
}

CollectionViewMenu.propTypes = {
  type: pt.string,
  setOrder: pt.func,
  switchMenu: pt.func,
  itemsOrder: pt.func,
  setThumbnailType: pt.func,
  setLayoutType: pt.func,
  viewSettings: pt.object
}

const makeMapStateToProps = () => {
  return (state, props) => {
    return {
      viewSettings: state.viewSettings
    }
  }
}

export default connect(
  makeMapStateToProps,
  {
    setLayoutType,
    setThumbnailType
  }
)(CollectionViewMenu)
